import { render } from "./CxCard.vue?vue&type=template&id=10a39476&scoped=true&ts=true"
import script from "./cxCardHelper.ts?vue&type=script&lang=ts"
export * from "./cxCardHelper.ts?vue&type=script&lang=ts"

import "./CxCard.vue?vue&type=style&index=0&id=10a39476&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a39476"]])

export default __exports__